import { useState, useCallback } from 'react';
import MyModal from '../../Common/my-modal/my-modal.component';
import styles from './index.module.scss';
import ProductForm from './product-form';
import { IProductFormValues } from '../../../common/validations/product.validations';
import { initialValues } from './initial-values';

interface AddProductModalProps {
  show: boolean;
  onHide: () => void;
}

const AddProductModal = ({ show, onHide }: AddProductModalProps) => {
  const [formValues, setFormValues] = useState<IProductFormValues | null>(null);
  const [isFormValid, setIsFormValid] = useState<boolean>(false);

  const handleFormStateChange = useCallback((values: IProductFormValues, isValid: boolean) => {
    setFormValues(values);
    setIsFormValid(isValid);
  }, []);

  const handleApply = async () => {
   
  };

  return (
    <MyModal show={show} onHide={onHide} className="" dialogClassName="">
      <MyModal.Header className="border-bottom" closeButton onCrossClick={onHide}>
        <MyModal.HeaderTitle className="text-align-center w-100">
          Add Product
        </MyModal.HeaderTitle>
      </MyModal.Header>
      <MyModal.Body className={styles.body}>
        <ProductForm 
          initialValues={initialValues}
          onFormStateChange={handleFormStateChange}
        />
      </MyModal.Body>
      <MyModal.Footer className="d-flex gap-4 border-top">
        <MyModal.CancelButton className="" onClick={onHide}>Cancel</MyModal.CancelButton>
        <MyModal.ApplyButton className="" red={false} onClick={handleApply} disabled={!isFormValid}>
          Add Product
        </MyModal.ApplyButton>
      </MyModal.Footer>
    </MyModal>
  );
};

export default AddProductModal;
